
import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authentication";
import tutorialsReducer from "./tutorials";
import eventsReducer from "./event";
import queryReducer from "./queries"
import livestreamSettings from "./livestreamSettings";
import languageReducer from "./language";
import settingsReducer from "./settings";
import chatsReducer from "./chat";
import notificationReducer from "./notification";
import tasksReducer from "./tasks";
import programsReducer from "./programs";
import badgesReducer from "./badges";
import faqsReducer from './faqsSlice'

import notepadReducer from "./notepad";
import countReducer from "./countReducer";
import todo from "./todo";
import visitingCard from "./visitingCard";
import profile from "./profile";
import session from "./session";

const appReducer  = combineReducers({
  notification: notificationReducer,
  countReducer: countReducer,
  todo,
  visitingCard,
  profile,
  session,
  language: languageReducer,
  faqs: faqsReducer,
  auth: authReducer,
  programs: programsReducer,
  tutorials: tutorialsReducer,
  events: eventsReducer,
  queries: queryReducer,
  tasks: tasksReducer,
  live: combineReducers({ settings: livestreamSettings, chats: chatsReducer, badges: badgesReducer, notepad: notepadReducer }),
  settings: combineReducers({ app: settingsReducer, langaguge: languageReducer }),
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "RESET_APP") {
    state = undefined; // 👈 clears all slices
  }
  return appReducer(state, action);
};

export default rootReducer;
